/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'profile': {
    width: 31,
    height: 32,
    viewBox: '0 0 31 32',
    data: '<g _fill="none" fill-rule="evenodd" _stroke="#000" stroke-width="2" transform="translate(1)"><path pid="0" d="M29 32c0-7.732-6.492-14-14.5-14S0 24.268 0 32"/><circle pid="1" cx="15" cy="9" r="8"/></g>'
  }
})
